import apiClient from './apiClient'

export interface ActivityLogDto {
  id: number
  timestamp: string     // ISO UTC
  userEmail: string
  userRole: string
  action: string
  entityType: string
  entityId: string | null
  description: string
}

export interface ActivityLogsResult {
  items: ActivityLogDto[]
  totalCount: number
}

export interface ActivityLogsParams {
  page?: number
  pageSize?: number
  from?: string         // ISO date yyyy-mm-dd
  to?: string           // ISO date yyyy-mm-dd
  userEmail?: string
  action?: string
  entityType?: string
}

export type ActivityLogExportParams = Omit<ActivityLogsParams, 'page' | 'pageSize'>

export const activityLogService = {
  getAll: (params?: ActivityLogsParams) =>
    apiClient
      .get<ActivityLogsResult>('/activity-log', { params })
      .then(r => r.data),

  exportExcel: async (params?: ActivityLogExportParams) => {
    const response = await apiClient.get('/activity-log/export', {
      params,
      responseType: 'blob',
    })
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const a = document.createElement('a')
    a.href = url
    a.download = `log-aktivit-${new Date().toISOString().slice(0, 10)}.xlsx`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  },

  deleteAll: () =>
    apiClient.delete<{ deleted: number }>('/activity-log').then(r => r.data),
}
